

















































import Vue from "vue";

import store from "@/store";
import { Resource } from "@/store/types";

import Search from "../body/Search.vue";

interface Item {
  name: string;
  link: string;
  active: boolean;
}

interface MenuItem {
  name: string;
  path: string;
  items: Item[];
  expanded: boolean;
}

export default Vue.extend({
  name: "NavBar",
  components: { Search },
  data() {
    return {
      open: false,
      searchText: "",
    };
  },
  computed: {
    general() {
      return store.getters.general;
    },
    sortAlgorithms() {
      return store.getters.sortAlgorithms;
    },
    searchAlgorithms() {
      return store.getters.searchAlgorithms;
    },
    dataStructures() {
      return store.getters.dataStructures;
    },
    menuItems(): MenuItem[] {
      const menuItems = [
        {
          name: "General",
          path: "general",
          items: this.getItemsModal(this.general),
        },
        {
          name: "Sort Algorithms",
          path: "algorithms",
          items: this.getItemsModal(this.sortAlgorithms),
        },
        {
          name: "Search Algorithms",
          path: "algorithms",
          items: this.getItemsModal(this.searchAlgorithms),
        },
        {
          name: "Data Structures",
          path: "data-structures",
          items: this.getItemsModal(this.dataStructures),
        },
      ];
      // Appended expanded prop and filter out any menu items that have no nested items
      return menuItems
        .map((menuItem) => ({
          ...menuItem,
          expanded: Boolean(
            this.searchText || menuItem.items.find((item) => item.active)
          ),
        }))
        .filter((menuItem) => menuItem.items.length > 0);
    },
  },
  methods: {
    getItemsModal(items: Resource[]): Item[] {
      return items
        .filter((item) =>
          item.name.toLowerCase().includes(this.searchText.toLowerCase())
        )
        .map((item) => {
          const currentResource = this.$route.params.name;

          const active = item.resource === currentResource;

          return { name: item.name, link: item.resource, active };
        });
    },
    onClose() {
      this.open = false;
      this.searchText = "";
    },
  },
});
